import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=2903dfcb&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=2903dfcb&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=2903dfcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903dfcb",
  null
  
)

export default component.exports